import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const allCamerasFilter = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => allFeatures,
        order: 1000,
    };

    return new FilterLayer('all-traffic-cameras', layers, { ...defaultOptions, ...options });
};
